<script setup>
import { computed } from 'vue';
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
  appearance: {
    type: Object,
    default: () => ({}),
  },
});

const { formatMessage } = useMessageFormatter();

const isDefaultScreen = computed(() => {
  return (
    props.config.isDefaultScreen &&
    ((props.config.welcomeHeading &&
      props.config.welcomeHeading.length !== 0) ||
      (props.config.welcomeTagLine && props.config.welcomeTagline.length !== 0))
  );
});

const subtitleFontSize = computed(() => {
  const px = props.appearance?.fontSizePx || 16;
  return `${Math.max(10, Math.round(px * 0.75))}px`;
});
</script>

<template>
  <div
    class="rounded-t-lg flex-shrink-0 transition-[max-height] duration-300 px-4"
    :class="isDefaultScreen ? 'py-5' : 'p-4'"
    :style="{
      backgroundColor: appearance?.backgroundColor,
      fontSize: appearance?.fontSize,
    }"
  >
    <div class="relative top-px">
      <div class="flex items-center justify-start">
        <img
          v-if="config.logo"
          :src="config.logo"
          class="mr-2 rounded-full logo"
          :class="!isDefaultScreen ? 'h-8 w-8 mb-1' : 'h-12 w-12 mb-2'"
        />
        <div v-if="!isDefaultScreen">
          <div class="flex items-center justify-start gap-1">
            <span
              class="font-medium leading-3"
              :style="{
                fontSize: appearance?.fontSize,
                color: appearance?.textColor,
              }"
            >
              {{ config.websiteName }}
            </span>
            <div
              v-if="config.isOnline"
              class="w-2 h-2 bg-n-teal-10 rounded-full"
            />
          </div>
          <span
            class="mt-1"
            :style="{
              fontSize: subtitleFontSize,
              color: appearance?.mutedTextColor,
            }"
          >
            {{ config.replyTime }}
          </span>
        </div>
      </div>
      <div v-if="isDefaultScreen" class="overflow-auto max-h-60">
        <h2
          class="mb-2 break-words font-semibold leading-tight"
          :style="{
            fontSize: `calc(${appearance?.fontSize} * 1.35)`,
            color: appearance?.textColor,
          }"
        >
          {{ config.welcomeHeading }}
        </h2>
        <p
          v-dompurify-html="formatMessage(config.welcomeTagline)"
          class="break-words [&_a]:underline leading-normal"
          :style="{
            fontSize: appearance?.fontSize,
            color: appearance?.mutedTextColor,
          }"
        />
      </div>
    </div>
  </div>
</template>
